import { useState, useEffect } from 'react';
import ExternalLinkIcon from '../assets/footer-new-window.svg';
import './ViewReportLink.css';

interface ViewReportLinkProps {
  fetchUrl: () => Promise<string | null>;
}

const ViewReportLink = ({ fetchUrl }: ViewReportLinkProps) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const url = await fetchUrl();
        if (!cancelled) setPdfUrl(url);
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [fetchUrl]);

  if (loading) return <span className="view-report-link-loading">Loading...</span>;

  if (error || !pdfUrl) return null;

  return (
    <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="view-report-link">
      <img src={ExternalLinkIcon} alt="external link" className="view-report-link-icon" />
      <span>View report</span>
    </a>
  );
};

export default ViewReportLink;
